import { render, staticRenderFns } from "./NewCredit.vue?vue&type=template&id=78623854&scoped=true&"
import script from "./NewCredit.vue?vue&type=script&lang=ts&"
export * from "./NewCredit.vue?vue&type=script&lang=ts&"
import style0 from "./NewCredit.vue?vue&type=style&index=0&id=78623854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78623854",
  null
  
)

export default component.exports